module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/app-store-badge-f34e9a284a36ff72c6d65f3e62f14eaf.svg";